// @ constants
const actionTypes = require('constants/actionTypes');

// @ commons
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { countActiveFilters } = require('utilities/filtersHelper');

const applyOpenYoungCardChoresFilter = filters => ({
    type: actionTypes.OPENYOUNG_CARD_GET_CHORE_APPLY_FILTER,
    payload: {
        filters
    }
});

const requestResetOpenYoungCardChoresFilter = filterKey => ({
    type: actionTypes.OPENYOUNG_CARD_GET_CHORE_RESET_FILTER,
    payload: {
        filterKey
    }
});

const requestClearOpenYoungCardChoresFilter = () => ({
    type: actionTypes.OPENYOUNG_CARD_GET_CHORE_CLEAR_FILTER
});

const clearOpenYoungCardChoresFilter = () => (dispatch) => { // used to remove all applied filters
    dispatch(requestClearOpenYoungCardChoresFilter());
}

const setOpenYoungCardChoresFilter = filters => dispatch => {
    dispatch(applyOpenYoungCardChoresFilter(filters));
};

const resetOpenYoungCardChoresFilter = filter => (dispatch, getState) => { // used to remove a single filter at a time
    const immFilter = getState().openYoungCardChores.get('filters');

    if (countActiveFilters(immFilter) === 1) {
        dispatch(requestClearOpenYoungCardChoresFilter());
    }
    dispatch(requestResetOpenYoungCardChoresFilter(filter));
};

const getChoreListRequest = () => {
    return {
        type: actionTypes.OPENYOUNG_CARD_GET_CHORE_LIST_REQUEST
    }
}

const getChoreListSuccess = (choreList) => {
    return {
        type: actionTypes.OPENYOUNG_CARD_GET_CHORE_LIST_SUCCESS,
        payload:{
            choreList
        }
    }
}

const getChoreListError = (error) => {
    return {
        type: actionTypes.OPENYOUNG_CARD_GET_CHORE_LIST_ERROR,
        payload:{
            error
        }
    }
}

const getChoreList = (immCard, choreStatusIds=[], startDate='', endDate='') => (dispatch, getState) => {
    dispatch(getChoreListRequest());
    const panNumber = immCard.getIn(['interventionList',0,'pan']);
    const immFilter = getState().openYoungCardChores.get('filters');
    const dateIsActive = immFilter.getIn(['date', 'isActive']);
    choreStatusIds = immFilter.getIn(['status', 'isActive']) ? [immFilter.getIn(['status', 'status'])] : [];
    if (dateIsActive) {
        startDate = immFilter.getIn(['date', 'from']);
        endDate = immFilter.getIn(['date', 'to']);
    }

    const requestData = {
        query: {
            childDetail: {
                contractNumber: immCard.getIn(['contract','number']),
                pan: panNumber && panNumber.substr(-4),
                productCode: immCard.getIn(['contract','product'])
            },
            filter: {
                choreStatusIds,
                endDate,
                startDate
            }
        }
    }
    return APIPost({
        dispatch,
        url: apiURLBuilder.getURL('openYoungGetChoreList'),
        params: requestData
    })
    .then(response => dispatch(getChoreListSuccess(response)))
    .catch(response => {
        if (!!response.error) {
            dispatch(getChoreListError(response.error.description));
        } else {
            throw response;
        }
    });
}

const getChoreDetailRequest = () => {
    return {
        type: actionTypes.OPENYOUNG_CARD_GET_CHORE_DETAIL_REQUEST
    }
}

const getChoreDetailError = (error) => {
    return {
        type: actionTypes.OPENYOUNG_CARD_GET_CHORE_DETAIL_ERROR,
        payload:{
            error
        }
    }
}

const getChoreDetailSuccess = (choreDetail) => {
    return {
        type: actionTypes.OPENYOUNG_CARD_GET_CHORE_DETAIL_SUCCESS,
        payload:{
            choreDetail
        }
    }
}

const getChoreDetail = (referenceId, data = {}) => (dispatch) => {
    dispatch(getChoreDetailRequest());

    return APIGet({
        dispatch,
        url: apiURLBuilder.getURL('openYoungGetChoreDetail', { choreAssignmentId: referenceId })
    })
    .then(response => {
        response && (response.isExpanded = data.isExpanded);
        dispatch(getChoreDetailSuccess(response));
        data.successCallback && data.successCallback(data.path, response);
    })
    .catch(response => {
        if (!!response.error) {
            data.errorCallback &&  data.errorCallback();
            dispatch(getChoreDetailError(response.error.description));
        } else {
            throw response;
        }
    });
}

module.exports = {
    clearOpenYoungCardChoresFilter,
    getChoreDetail,
    getChoreList,
    resetOpenYoungCardChoresFilter,
    setOpenYoungCardChoresFilter
}
